import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, description, moreTo, moreLabel }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2.5 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          <span className="w-1.5 h-6 rounded-full bg-primary-500" />
          {title}
        </h2>
        {description ? <p className="mt-1.5 text-xs md:text-sm text-foreground-500">{description}</p> : null}
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors"
        >
          {moreLabel || "查看全部"}
          <i className="ri-arrow-right-s-line" />
        </Link>
      ) : null}
    </div>
  );
}